import React from 'react'
import { CatalogoProductInfo } from '../../../../../shared/catalogo/producto/ficha/CatalogoProductInfo'
import styles from './destacamos.module.scss'
import SectionWithHeading from '../../../../../shared/components/SectionWithHeading/SectionWithHeading'
import { locale, t, textWithLocale } from '../../../../i18n'
interface Props {
  producto: CatalogoProductInfo
}
export const Destacamos: React.FC<Props> = ({ producto }) => (
  <SectionWithHeading
    title={t('catalogo.producto.ficha.section_destacamos.title')}>
    <div className={styles.highlights}>
      {producto[textWithLocale('caracteristicas1')] && (
        <div className={styles.highlight}>
          <span className={styles.arrow}>➜</span>
          <span className="text">
            {producto[textWithLocale('caracteristicas1')]}
          </span>
        </div>
      )}
      {producto[textWithLocale('caracteristicas2')] && (
        <div className={styles.highlight}>
          <span className={styles.arrow}>➜</span>
          <span className="text">
            {producto[textWithLocale('caracteristicas2')]}
          </span>
        </div>
      )}
      {producto[textWithLocale('caracteristicas3')] && (
        <div className={styles.highlight}>
          <span className={styles.arrow}>➜</span>
          <span className="text">
            {producto[textWithLocale('caracteristicas3')]}
          </span>
        </div>
      )}
      {producto[textWithLocale('caracteristicas4')] && (
        <div className={styles.highlight}>
          <span className={styles.arrow}>➜</span>
          <span className="text">
            {producto[textWithLocale('caracteristicas4')]}
          </span>
        </div>
      )}
    </div>
  </SectionWithHeading>
)
